import * as React from 'react';
import b_ from 'b_';
import { useTranslation } from 'react-i18next';
import MoneyView from 'shared/components/MoneyView';
import { Investment_BuyOrderStatus } from 'types/common';
import { OrderFragment } from './__generated__/OrderFragment';
import { Actions } from './components/Actions';
import { Status } from './components/Status';
import HaveOrderNotice from './components/HaveOrderNotice';
import { Product } from './components/Product';

import './index.scss';

type Order = OrderFragment;

export { Order };

interface Props {
  order: Order;
  forIdeaPage?: boolean;
}

const b = b_.with('order-card');

export const OrderView: React.FC<Props> = ({ order, forIdeaPage }) => {
  const { t } = useTranslation();

  return (
    <div className={b()} data-testid="order-card">
      {forIdeaPage && order.__typename === 'Investment_BuyOrder' ? (
        <HaveOrderNotice
          className={b('head')}
          canReject={order.status === Investment_BuyOrderStatus.ACCEPTED}
        />
      ) : (
        order.product && <Product className={b('head')} product={order.product} />
      )}
      <div className={b('info')}>
        <div className={b('items')}>
          <div className={b('amount')}>
            <span className={b('title')}>{t('Order amount')}</span>
            <span className={b('value')}>
              <MoneyView precision={0} data-testid="amount">
                {order.requestAmount}
              </MoneyView>
            </span>
          </div>
          <div className={b('status')}>
            <span className={b('title')}>{t('Status')}</span>
            <Status order={order} />
          </div>
          <div className={b('buttons')}>
            <Actions order={order} />
          </div>
        </div>
      </div>
    </div>
  );
};
